import { Component } from "react";
import "./LegalDocumentsPanel.css";
import PropTypes from "prop-types";
import LegalLink from "./../LegalLink/LegalLink";
import { strings } from "../data/strings";
import Text from "./../../Text/Text";
import {
  TERMS_OF_USE_URL,
  PRIVACY_POLICY_URL,
  COOKIE_POLICY_URL,
  IMPRINT_URL,
} from "services/util";

/**
 * A panel that contains all the links to different legal documents.
 */
export default class LegalDocumentsPanel extends Component {
  render() {
    return (
      <span className="terms-privacy">
        <LegalLink
          label={<Text strings={strings} strKey="terms_link" />}
          documentUrl={TERMS_OF_USE_URL}
          language={undefined}
        />
        <LegalLink
          label={<Text strings={strings} strKey="privacy_link" />}
          documentUrl={PRIVACY_POLICY_URL}
          language={undefined}
        />
        <LegalLink
          label={<Text strings={strings} strKey="cookies_link" />}
          documentUrl={COOKIE_POLICY_URL}
          language={undefined}
        />
        <LegalLink
          label={<Text strings={strings} strKey="imprint_link" />}
          documentUrl={IMPRINT_URL}
          language={this.props.language}
        />
      </span>
    );
  }
}

LegalDocumentsPanel.propTypes = {
  /**
   * A current language (default language of the browser or selected by user).
   * It is a [language tag](https://www.w3.org/International/articles/language-tags/) like 'en' for English.
   */
  language: PropTypes.string,
};
